import { Blue100, ButtonIcon, Dropdown, Menu, MenuItem } from '@traceair/tds';
import { MoreIcon } from '@traceair/webapp-icons';
import React, { useState } from 'react';
import { DateChangeIcon } from '../../../../../images/components/DateChangeIcon';
import { useAppStore } from '../../../../../store/appStore';
import { MissionData } from '../../types';

interface Props extends MissionData {}

export const MissionCardMenu = (mission: Props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { setSelectedDateChangeMission } = useAppStore();

  const handleMenuToggle = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const handleDateChangeToggle = (event: React.MouseEvent) => {
    event.stopPropagation();
    setSelectedDateChangeMission({ mission });
    setIsMenuOpen(false);
  };

  const menu = (
    <Menu width="212px">
      <MenuItem onClick={handleDateChangeToggle} icon={<DateChangeIcon />} title="Change mission date" />
    </Menu>
  );

  return (
    <Dropdown
      closeOnOverlayClick
      overlay={menu}
      placement="bottomRight"
      trigger="click"
      open={isMenuOpen}
      onOpenChange={setIsMenuOpen}
    >
      <ButtonIcon icon={<MoreIcon color={Blue100} />} size="xs" style="tertiary" onClick={handleMenuToggle} />
    </Dropdown>
  );
};
